module.exports = __webpack_public_path__ + "img/loginSchoolIconNew.f95ca0b2.png";